import React, { lazy, Suspense } from "react";
import { Toaster } from "react-hot-toast";
import LoadingScreen from "./components/LoadingScreen";
import {
  About,
  Contact,
  Experience,
  Feedbacks,
  Hero,
  Navbar,
  Tech,
  Works,
  StarsCanvas,
} from "./components";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

const Home = Loadable(lazy(() => import("./pages/Home")));
const NotFound = Loadable(lazy(() => import("./pages/NotFound")));

function App() {
  return (
    <div className="relative z-0 bg-primary">
      
      <Toaster position="top-right" />

      <div className="bg-hero-pattern bg-cover bg-no-repeat bg-center">
        <Navbar />
        <Hero />
      </div>

      <About />

      <Experience />

      <Tech />

      <Works />
      
      <Feedbacks />

      <div className="relative z-0">
        <Contact />
        <StarsCanvas />
      </div>

    </div>
  );
}

export default App;
